import { render, staticRenderFns } from "./ParamsList.vue?vue&type=template&id=371ab1f8&scoped=true"
import script from "./ParamsList.vue?vue&type=script&lang=ts"
export * from "./ParamsList.vue?vue&type=script&lang=ts"
import style0 from "./ParamsList.vue?vue&type=style&index=0&id=371ab1f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371ab1f8",
  null
  
)

export default component.exports